import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";

import check from "assets/svg/success.svg";
import { useMemo } from "react";
import { APP_CONFIG } from "config/appConfig";

const MESSAGE_CONFIG: {
    [key: string]: {
        title: string;
        message: string;
        buttonText: string;
    };
} = {
    keycloak: {
        title: "Your account is ready",
        message: "You can now sign in using your email and password.",
        buttonText: "SIGN IN",
    },
    local: {
        title: "Verified Successfully",
        message:
            "Your account has been verified successfully. Login to continue",
        buttonText: "LOGIN",
    },
};

type VerificationSuccessProps = {
    onSignIn: () => void;
};

const VerificationSuccess = ({ onSignIn }: VerificationSuccessProps) => {
    const isOnPremAuth = APP_CONFIG.APP_IS_ONPREM;
    const messages = useMemo(() => {
        return isOnPremAuth ? MESSAGE_CONFIG.keycloak : MESSAGE_CONFIG.local;
    }, [isOnPremAuth]);

    return (
        <Col lg="6" sm="12" className="login-form">
            <div className="login-box">
                <div className="login-table">
                    <div className="login-text">
                        <img src={check} alt="" />
                        <h4 className="mt-4">{messages.title}</h4>
                    </div>
                    <div className="mt-5 mb-5">{messages.message}</div>
                    <Link
                        onClick={onSignIn}
                        to="#"
                        className="btn btn-primary"
                    >
                        {messages.buttonText}
                    </Link>
                </div>
            </div>
        </Col>
    );
};

export default VerificationSuccess;
